import reducer from './reducer'

import * as wireInstructionsOperations from './operations'
import * as wireInstructionsSelectors from './selectors'

export { wireInstructionsOperations, wireInstructionsSelectors }

export default reducer
